import React from 'react';

class ListErrors extends React.Component {
  render() {
    const errors = this.props.errors;
    if (errors) {
      const listItems = errors.map((error, index) => 
        <li key={index}>{error.err_01}</li>
      )
      return (
        <ul className="error-messages">
          {listItems}
        </ul>
      );
    } else {
      return null;
    }
  }
}

export default ListErrors;



// WEBPACK FOOTER //
// ./src/containers/ListErrors.js